var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BookingEmailHeader'),_c('NoEmailAlert'),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-col',{staticStyle:{"height":"100%","overflow":"auto"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }